export type NoticePlatform = 'ALL' | 'ANDROID' | 'IOS';

export const PLATFORM_LABELS: Record<NoticePlatform, string> = {
    ALL: '전체',
    ANDROID: 'Android',
    IOS: 'iOS',
};

export interface NoticeItem {
    id: number;
    title: string;
    content: string;
    priority: number;
    platform: NoticePlatform;
    minAppVersionCode?: number;
    maxAppVersionCode?: number;
    isActive: boolean;
    startAt: string;
    endAt?: string;
    createdAt: string;
    updatedAt: string;
}

export interface CreateNoticeRequest {
    title: string;
    content: string;
    priority: number;
    platform: NoticePlatform;
    minAppVersionCode?: number;
    maxAppVersionCode?: number;
    startAt: string;
    endAt?: string;
}

export interface UpdateNoticeRequest {
    title: string;
    content: string;
    priority: number;
    platform: NoticePlatform;
    minAppVersionCode?: number;
    maxAppVersionCode?: number;
    isActive: boolean;
    startAt: string;
    endAt?: string;
}

export interface NoticeFilterParams {
    page: number;
    size: number;
    isActive?: boolean;
}
